export default __webpack_public_path__ + "static/media/distelli.4cc77e22.svg";